import {
  CustomFieldsFieldTypeEnum,
  EditCustomTablePageSchemaFieldValueFragment,
} from 'generated/resources/graphql'

export const coerceFieldValue = (
  fieldType: CustomFieldsFieldTypeEnum,
  value?: EditCustomTablePageSchemaFieldValueFragment
) => {
  if (!value) return null

  switch (fieldType) {
    case 'text':
    case 'long_text':
      return value.longTextValue ?? ''
    case 'single_choice':
      return value.singleChoiceValue ?? ''
    case 'cents':
      // Convert null to undefined for cents fields (factorial-form doesn't accept null for numeric fields)
      return value.centsValue ? Number(value.centsValue) : null
    case 'date':
      return value.dateValue ?? null
  }

  return null
}
